module.exports = __webpack_public_path__ + "img/logo-color-120.be2ae170.png";